import { Component, OnInit } from '@angular/core';
import { ClozeTestStyleModel } from 'gast-onset-ng/lib/cloze-test/model/cloze-test-style-model';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-ger-info',
  templateUrl: './ger-info.component.html',
  styleUrls: ['./ger-info.component.css']
})
export class GerInfoComponent implements OnInit {
  mobileMode = false;
  cTestLogo: string;
  clozeTestStyleModel: ClozeTestStyleModel;
  cTestButtonColor: string;
  lang = 'de';

  constructor(private deviceService: DeviceDetectorService) { }

  ngOnInit() {
    // detect mobile
    this.mobileMode = this.deviceService.isMobile();
    this.clozeTestStyleModel = this.generateClozeTestStyle();
    this.cTestButtonColor = this.clozeTestStyleModel.onsetColor;
    // set logo and button color
    this.cTestLogo = 'onset-assets/img/onset_logo.png';
  }


  private generateClozeTestStyle(): ClozeTestStyleModel {
    // TODO config
    const model = {} as ClozeTestStyleModel;
    model.siteBackground = '#ffffff';
    model.exerciseBackground = '#EEF3F8';
    model.frameColor = '#92aac1';
    model.barColor = '#b3c9de';
    model.specialCharacterListColor = '#b3c9de';
    model.specialChcaracterTextColor = '#000000';
    model.exerciseTextColor = '#000000';
    model.buttonsColor = '#fa9463';
    model.testdafColor = '#57a7d6';
    model.onsetColor = '#a5d8db';
    model.duoColor = '#ed6a5b';
    model.testasColor = '#fac075';
    model.font = 'arial, helvetica, sans-serif';
    model.fontSize = '11pt';
    model.displayLogo = true;
    model.cTestInformationUrl = 'https://www.onset.de/onset/durchfuehrung/zusatz.jsp';
    return model;
  }
}
